<template>
    <v-app class="layout-auth-sample">
        <v-main>
            <v-container fluid class="fill-height pa-0">
                <transition name="fade" mode="out-in" appear>
                    <router-view />
                </transition>
            </v-container>
        </v-main>

        <x-show-message></x-show-message>
    </v-app>
</template>

<script>
export default {
    name: 'LayoutAuth',
    components: {
    },
    data() {
        return {

        }
    },
    methods: {
        openExternalPath(app) {
            const route = this.$router.resolve({ path: app.path });
            window.open(route.href, '_blank');
        },
    },
    
}
</script>

<style scoped>
.fade-enter{
    opacity: 0;
}
.fade-enter-active{
    transition: all .4s ease;
}
</style>
